import React, { useState, useEffect, useContext } from 'react';
import {
  AppContext,
  SuperTable,
  SkeletonTableLoading,
  getDefaultValue,
  updateConditions,
  getDateOperators,
  getUnifiedConditions,
  ALL_TABLES,
  getTableRowCount,
  saveTableRowCount,
  getAllColumnWidth,
  saveColumnWidth,
  getTranslatedText,
  EventEmitter
} from '@nile/components';
import { useKbContext } from '../../contexts/KbContext';
import { useIntl } from 'react-intl';
import {
  KB_FEEDBACK_LIST_VIEW_META,
  GET_KB_ARTICLE_FEEDBACKS
} from '@nile/rmm/src/modules/knowledge-base/graphql';
import { AccountClient, GET_ENTITY_NAMES_META, RMMClient } from '@nile/graphql';
import { useQuery, useLazyQuery } from '@apollo/client';
import { getProcessedConfig } from '@nile/rmm/src/modules/common/services/tableHelper';
import TextCell from '@nile/banyan/src/Components/Tables/TextCell';
import {
  checkDynamicQuery,
  getVariables,
  getWidthPersonalization,
  getColumnCellType,
  getAccessor,
  getEntityAttributeName,
  generateOptions,
  getDynamicQuery,
  checkCustomAttribute
} from './table-helper';
import { CollectionCell, DeleteCell } from './cells';
import { KB_CONSTANTS } from '@nile/rmm/src/modules/knowledge-base';
import envConfig from '@nile/home/src/Config/env';
import DateCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/date-cell';
import AvatarCell from '@nile/reports/src/modules/reports/components/subpages/HistoryTable/Cell/AvatarCell';
import { isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { KB_ARTICLE_MODULE } from '../../helper/constants';
import AutoInfoCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/auto-info-text-cell';

const KbFeedbackListView = ({ history }) => {
  const { activeViewConfig, treeItems, setFilterConditions } = useKbContext();
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const tabContext = useContext(TabContext);
  const intl = useIntl();
  const [kbListItems, setKbListItems] = useState([]);
  const [viewConditions, setViewConditions] = useState();
  const [listInfo, setListInfo] = useState({});
  const tableName = ALL_TABLES.kbFeedbackTable;
  const columnWidthObject = getAllColumnWidth(tableName);
  const ROW_COUNT = getTableRowCount(tableName);
  const [rowCount, setRowCount] = useState(ROW_COUNT);
  const [totalCount, setTotalCount] = useState(0);

  const { loading: kbFeedbackViewMetaLoading, data: kbListViewMeta } = useQuery(
    KB_FEEDBACK_LIST_VIEW_META,
    {
      client: AccountClient
    }
  );

  const {
    data: entityMeta = { getEntitiesMeta: [] },
    loading: entityDataLoading
  } = useQuery(GET_ENTITY_NAMES_META, {
    client: RMMClient,
    variables: {
      entitiesName: ['User', 'KbItem', 'KbArticle', 'KbArticleFeedback']
    }
  });

  const [getKbArticleFeedbacksList, { data, loading, error }] = useLazyQuery(
    GET_KB_ARTICLE_FEEDBACKS,
    {
      client: AccountClient,
      fetchPolicy: 'no-cache',
      onCompleted: ({ getKbArticleFeedbacks: data }) => {
        setTotalCount(data?.listInfo.totalCount || 0);
        setListInfo(data?.listInfo);
        setKbListItems(data?.articleFeedbacks);
      }
    }
  );

  useEffect(() => {
    setFilterConditions(null);
    fetchItems();
    return () => {
      setFilterConditions(null);
    };
  }, [activeViewConfig]);

  const columnsConfig = {
    TEXT: TextCell,
    AVATAR: AvatarCell,
    COLLECTION: CollectionCell,
    DATE: DateCell,
    DELETE: DeleteCell,
    FEEDBACK: AutoInfoCell
  };

  const { configuredCols } = getProcessedConfig({
    entitiesMeta: entityMeta?.getEntitiesMeta || [],
    allColumns:
      kbListViewMeta?.getKbArticleFeedbackListViewMeta
        ?.defaultSelectedAttributes,
    intl,
    module: 'KbArticleFeedback',
    columnPersonalization: [],
    searchAttributes:
      kbListViewMeta?.getKbArticleFeedbackListViewMeta?.searchAttributes
  });
  const columnsss = configuredCols || [];

  columnsss.push({
    name: 'delete',
    label: '',
    table: 'KbFeedback',
    dataType: 'delete',
    id: 'delete'
  });

  const handleCollectionActions = (col) => {
    tabContext.openTab({
      module: KB_ARTICLE_MODULE,
      url: `/kb/article/${col?.kbArticle?.itemId}/read`,
      data: { ...col, id: col?.kbArticle?.itemId }
    });
  };

  const handleColActions = (col) => {
    switch (col.id) {
      case 'name':
      case 'kbArticle.name':
        return {
          onClick: handleCollectionActions
        };
      default:
        return {};
    }
  };

  const fetchItems = (updatedCondition = null, options = {}) => {
    const queryListInfo = {
      page: 1,
      pageSize: ROW_COUNT,
      sort: listInfo?.sort
    };

    const defaultOperands = [
      {
        attribute: 'status',
        operator: 'is',
        value: 'unresolved'
      }
    ];

    if (!isEmpty(options)) {
      getKbArticleFeedbacksList({
        variables: {
          listInfo: {
            ...options,
            condition: options?.condition || {
              joinOperator: 'AND',
              operands: [
                {
                  joinOperator: 'AND',
                  operands: defaultOperands
                }
              ]
            }
          }
        }
      });
      return;
    }

    if (!updatedCondition) {
      getKbArticleFeedbacksList({
        variables: {
          listInfo: {
            ...queryListInfo,
            condition: {
              joinOperator: 'AND',
              operands: [
                {
                  joinOperator: 'AND',
                  operands: defaultOperands
                }
              ]
            }
          }
        }
      });
      setViewConditions(null);
      setFilterConditions(null);
      return;
    }

    const params = {
      conditions: viewConditions,
      defaultCondition: [],
      updatedCondition: updatedCondition
    };
    const complexCondition = getUnifiedConditions(params);
    setViewConditions(complexCondition);
    setFilterConditions({
      condition: true,
      resetFilter: () => {
        setViewConditions(null);
        fetchItems();
      }
    });

    getKbArticleFeedbacksList({
      variables: {
        listInfo: {
          ...queryListInfo,
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                joinOperator: 'AND',
                operands: defaultOperands
              },
              complexCondition
            ]
          }
        }
      }
    });
  };

  const constructUnifiedConditions = (updatedCondition) => {
    fetchItems(updatedCondition);
  };

  function updateAllConditions(condition, selectedField) {
    updateConditions({
      condition,
      selectedField,
      viewConditions: viewConditions?.operands?.[0] || null,
      setConditions: constructUnifiedConditions,
      getCustomAttributes: getEntityAttributeName
    });
  }

  const allColumns = columnsss?.map((col) => {
    return {
      header: col.label,
      tableName: tableName,
      // accessor: getAccessor(col),
      accessorKey: getAccessor(col),
      // minSize: getColumnWidth(col),
      // maxSize: getMaxWidth(columnWidthObject, col.id),
      size: getWidthPersonalization(columnWidthObject, col.id),
      id: col?.id,
      type: getColumnCellType(col),
      disableSortBy: kbListViewMeta?.getKbArticleFeedbackListViewMeta?.sortAttributes?.includes(
        col.id
      )
        ? false
        : true,
      disableFilters: col?.id === 'delete' ? true : false,
      disableResizing: false,
      field: col,
      actions: handleColActions(col),
      helpers: {
        getDefaultValue,
        checkDynamicQuery,
        getDynamicQuery,
        generateOptions,
        checkCustomAttribute: checkCustomAttribute,
        getConditionAttributes: getEntityAttributeName,
        getVariables: getVariables.bind(this, col),
        updateConditions: updateAllConditions,
        getDateOperators,
        entity: 'KbArticleFeedback'
      }
    };
  });

  function refreshTable(context, data) {
    if (data) {
      const options = {
        page: data?.page || 1,
        pageSize: ROW_COUNT,
        sort: data?.sort ? data?.sort : listInfo?.sort,
        condition: listInfo?.condition
      };
      fetchItems(null, options);
    }
  }

  useEffect(() => {
    EventEmitter.subscribe(KB_CONSTANTS.KB_FB_LIST_TABLE_REFETCH_EVENT, () => {
      fetchItems();
    });
    return () => {
      EventEmitter.unsubscribe(KB_CONSTANTS.KB_FB_LIST_TABLE_REFETCH_EVENT);
    };
  }, []);

  return (
    <div className="full-height">
      {entityDataLoading || kbFeedbackViewMetaLoading ? (
        <SkeletonTableLoading borderTop />
      ) : (
        <SuperTable
          data={kbListItems || []}
          columns={[{ Header: 'Name', header: 'name', columns: allColumns }]}
          isLoading={loading}
          listInfo={listInfo}
          refreshTable={refreshTable}
          defaultColumnCells={columnsConfig}
          noBulkSelect
          context={{
            records: [],
            viewConditions: viewConditions?.operands?.[0] ?? null
          }}
          columnWidthPersonalization
          tableName={tableName}
          user={user}
          saveColumnWidth={saveColumnWidth}
          saveTableRowCount={saveTableRowCount}
          rowCount={rowCount}
          getEntityAttributeName={getEntityAttributeName}
          getAttributeName={getEntityAttributeName}
          setRowCount={setRowCount}
          recordCount={totalCount}
          fullHeight
          emptyState={{
            nodataImage: `${envConfig.imageRoot}svg/kb-not-found.svg`,
            heading: getTranslatedText(intl, 'app.kb.list.noItems.heading')
            // description: getTranslatedText(intl, 'app.kb.noItems.description')
          }}
        />
      )}
    </div>
  );
};

export default withRouter(KbFeedbackListView);
